import React, { FC } from 'react';

type AppComponentProps = {
  children?: JSX.Element;
};

export const App: FC<AppComponentProps> = ({ children }) => {
  return <>{children}</>;
};
